.actions{display:flex;gap:8px}:host:has(.sampling-nav){display:block}
/*# sourceMappingURL=sampling-workspace-navbar.component.css.map */
